export default __webpack_public_path__ + "static/media/sha256_devices.f7ece04d.csv";